module.exports = __webpack_public_path__ + "img/pc-tmt-logo.8461817c.svg";